function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.872,24.961l-2.539,0.412c-0.711,0.114-1.4-0.058-1.961-0.468c-0.558-0.401-0.94-1.031-1.043-1.72l-0.223-1.482 L1.699,26.11c-0.219,0.219-0.299,0.542-0.207,0.838c0.092,0.296,0.34,0.519,0.645,0.575l2.801,0.523l0.523,2.801 c0.057,0.305,0.278,0.554,0.574,0.646c0.296,0.093,0.62,0.013,0.839-0.208l5.755-5.755l-0.422-0.427 C12.118,25.012,11.996,24.961,11.872,24.961z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.91,23.932l2.458,0.404c0.411,0.068,0.833-0.031,1.17-0.277c0.336-0.243,0.562-0.614,0.624-1.026l0.37-2.458 c0.075-0.492,0.383-0.917,0.829-1.141l2.224-1.111c0.372-0.188,0.656-0.516,0.784-0.912c0.13-0.396,0.093-0.828-0.098-1.199 L27.129,14c-0.229-0.438-0.229-0.964,0-1.403l1.144-2.211c0.19-0.37,0.227-0.802,0.098-1.199 c-0.129-0.394-0.412-0.723-0.785-0.911l-2.223-1.112c-0.447-0.224-0.754-0.648-0.829-1.14l-0.37-2.458 c-0.062-0.412-0.288-0.782-0.624-1.026c-0.337-0.247-0.759-0.346-1.17-0.279l-2.457,0.405c-0.489,0.082-0.987-0.08-1.335-0.434 l-1.75-1.773C16.544,0.175,16.164,0.012,15.766,0c-0.398,0.013-0.779,0.175-1.061,0.459l-1.75,1.773 c-0.348,0.354-0.846,0.516-1.335,0.434L9.163,2.261C8.751,2.194,8.33,2.293,7.993,2.54C7.657,2.784,7.431,3.154,7.369,3.566 l-0.37,2.458C6.923,6.516,6.617,6.94,6.169,7.164L3.947,8.276C3.574,8.464,3.291,8.793,3.162,9.188 c-0.129,0.396-0.093,0.829,0.097,1.199l1.144,2.211c0.229,0.439,0.229,0.964,0,1.403L3.26,16.211 c-0.19,0.371-0.227,0.803-0.097,1.199c0.128,0.396,0.412,0.725,0.784,0.912l2.224,1.111C6.617,19.657,6.924,20.082,7,20.574 l0.37,2.458c0.062,0.412,0.288,0.783,0.624,1.026c0.337,0.246,0.759,0.346,1.17,0.277l2.458-0.404 c0.489-0.082,0.987,0.08,1.335,0.436l1.75,1.771c0.281,0.285,0.661,0.447,1.059,0.459c0.398-0.012,0.778-0.174,1.059-0.459 l1.75-1.771C18.923,24.012,19.421,23.85,19.91,23.932z M15.766,22.542c-5.205-0.026-9.431-4.266-9.431-9.477 c0-5.21,4.226-9.451,9.431-9.478c5.205,0.026,9.432,4.268,9.432,9.478C25.197,18.276,20.971,22.516,15.766,22.542z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.766,4.955c-4.444,0.028-8.05,3.648-8.05,8.097c0,4.447,3.606,8.068,8.05,8.096c4.444-0.027,8.05-3.648,8.05-8.096 C23.815,8.604,20.21,4.983,15.766,4.955z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.833,26.11l-4.407-4.407l-0.223,1.482c-0.104,0.688-0.485,1.318-1.043,1.72c-0.562,0.41-1.25,0.582-1.961,0.468 l-2.539-0.412c-0.124,0-0.246,0.051-0.335,0.143l-0.422,0.427l5.755,5.755c0.219,0.221,0.543,0.301,0.839,0.208 c0.296-0.092,0.517-0.341,0.574-0.646l0.522-2.801l2.801-0.523c0.306-0.057,0.554-0.279,0.646-0.575S30.052,26.329,29.833,26.11z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgIconBadge = function SvgIconBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "31.531px",
    height: "31.531px",
    viewBox: "0 0 31.531 31.531",
    style: {
      enableBackground: "new 0 0 31.531 31.531"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-badge.e8a0f273.svg";
export { ForwardRef as ReactComponent };